var _defs, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _g2, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _path30;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuiz(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 272,
    height: 295.734,
    viewBox: "0 0 272 295.734",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.022,
    y1: 0.5,
    x2: 1.061,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.056,
    stopColor: "#9f79b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.257,
    stopColor: "#a07bb9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#a782bf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.434,
    stopColor: "#b28fc8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "#c1a1d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507,
    stopColor: "#c3a5d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#ccb2dc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.533,
    stopColor: "#dac8e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.547,
    stopColor: "#eee6f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.556,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.568,
    stopColor: "#ebdff3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#ddc7ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.591,
    stopColor: "#d4b9e4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.658,
    stopColor: "#b294d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.715,
    stopColor: "#9b7ccb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.769,
    stopColor: "#8d6ec5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.813,
    stopColor: "#8969c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b086cc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2f054a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5824b0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d065f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5f27bd"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 0.5,
    cy: 0.5,
    r: 0.847,
    gradientTransform: "matrix(0.59, 0, 0, 0.591, 5.78, -20.571)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#972a74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.041,
    stopColor: "#8a266a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.194,
    stopColor: "#601a49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#3d112f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507,
    stopColor: "#22091a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667,
    stopColor: "#0f040b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.829,
    stopColor: "#030102"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -4.036,
    y1: 2.332,
    x2: -4.711,
    y2: 1.449,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d065f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#12054e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#10054d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 0.296,
    y1: -0.053,
    x2: 0.706,
    y2: 1.06,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.056,
    stopColor: "#9f79b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#a17bb9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.346,
    stopColor: "#a882c0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#b48fcb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484,
    stopColor: "#c5a2db"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539,
    stopColor: "#dbbaf0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.561,
    stopColor: "#e6c6fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.597,
    stopColor: "#d6b6f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.687,
    stopColor: "#b494dc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773,
    stopColor: "#9c7cce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.853,
    stopColor: "#8e6ec5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.919,
    stopColor: "#8969c3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 30.794,
    y1: -0.173,
    x2: 29.103,
    y2: 0.897,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 7.578,
    y1: 0.979,
    x2: 6.712,
    y2: 0.012,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.214,
    stopColor: "#6e41d1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.618,
    stopColor: "#4c9be8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2af6ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 7.425,
    y1: 1.023,
    x2: 6.589,
    y2: 0.061,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.056,
    stopColor: "#9f79b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.257,
    stopColor: "#a07bb9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#a782bf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.434,
    stopColor: "#b28fc8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "#c1a1d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507,
    stopColor: "#c3a5d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#ccb2dc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.533,
    stopColor: "#dac8e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.547,
    stopColor: "#eee6f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.556,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.568,
    stopColor: "#ebdff3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#ddc7ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.591,
    stopColor: "#d4b9e4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.612,
    stopColor: "#cfb1e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.756,
    stopColor: "#be99d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.889,
    stopColor: "#b38bce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b086cc"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 0.975,
    cy: 0.429,
    r: 0.103,
    gradientTransform: "translate(-2.981) scale(1.407 1)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 0.338,
    y1: 0.947,
    x2: 0.839,
    y2: 0.152,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.056,
    stopColor: "#e6e7e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.077,
    stopColor: "#ebeced"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#f3f4f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.217,
    stopColor: "#e6e7e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.581,
    stopColor: "#fafafb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.687,
    stopColor: "#d5cedb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.815,
    stopColor: "#ddd9e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e6e7e8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 6.973,
    y1: 26.689,
    x2: 0.39,
    y2: -0.177,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#25054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 5.762,
    y1: 21.889,
    x2: -0.637,
    y2: -4.082,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 5.256,
    y1: 19.925,
    x2: -1.851,
    y2: -9.097,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 3.81,
    y1: 13.986,
    x2: -2.675,
    y2: -12.346,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 6.777,
    y1: 25.885,
    x2: 0.193,
    y2: -0.981,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 5.571,
    y1: 21.117,
    x2: -0.829,
    y2: -4.861,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 5.043,
    y1: 19.057,
    x2: -2.064,
    y2: -9.965,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 6.577,
    y1: 25.072,
    x2: -0.006,
    y2: -1.793,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 5.377,
    y1: 20.331,
    x2: -1.022,
    y2: -5.646,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 4.828,
    y1: 18.179,
    x2: -2.279,
    y2: -10.843,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 3.42,
    y1: 12.399,
    x2: -3.065,
    y2: -13.928,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-3",
    cx: 0.646,
    cy: 1.509,
    r: 2.159,
    gradientTransform: "translate(0.183) scale(0.633 1)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    stopColor: "#8493ba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.212,
    stopColor: "#606c8f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.326,
    stopColor: "#434d6d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.434,
    stopColor: "#2f3755"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.533,
    stopColor: "#232947"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616,
    stopColor: "#1f2542"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.706,
    stopColor: "#242a48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.833,
    stopColor: "#33385b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.983,
    stopColor: "#4c5079"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.985,
    stopColor: "#4d517a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 142.813,
    y1: -42.061,
    x2: 143.481,
    y2: -42.061,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.035,
    stopColor: "#f7d9cf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#ffe1c2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.874,
    stopColor: "#f7cfc1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-4",
    cx: 0.956,
    cy: -0.038,
    r: 0.612,
    gradientTransform: "matrix(-0.494, 0.676, 0.173, 0.282, 120.699, -149.22)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-5",
    cx: 0.959,
    cy: -0.033,
    r: 0.609,
    gradientTransform: "matrix(-0.498, 0.676, 0.175, 0.282, 270.408, -333.116)",
    xlinkHref: "#radial-gradient-4"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-6",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    gradientTransform: "matrix(0, -1, -1, 0, 1248.406, 1248.733)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.131,
    stopColor: "#ff63ce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 0.59,
    y1: 0.261,
    x2: 0.501,
    y2: 0.555,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.035,
    stopColor: "#ffa98c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.317,
    stopColor: "#feb892"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#fee0a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feeca8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 0.575,
    y1: 0.295,
    x2: 0.434,
    y2: 0.731,
    xlinkHref: "#linear-gradient-22"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 0.485,
    y1: 0.577,
    x2: 0.619,
    y2: 0.145,
    xlinkHref: "#linear-gradient-22"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 169.658,
    y1: -38.805,
    x2: 170.47,
    y2: -38.805,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bec5d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.212,
    stopColor: "#ebedf3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#e1e4ec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498,
    stopColor: "#9096b2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616,
    stopColor: "#70789c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.681,
    stopColor: "#767da2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.774,
    stopColor: "#878eb5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.823,
    stopColor: "#949ac2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8b90b5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 149.314,
    y1: -134.029,
    x2: 151.924,
    y2: -133.894,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d6dae6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.015,
    stopColor: "#d4d8e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.278,
    stopColor: "#b4b8e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395,
    stopColor: "#999fc7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#8289af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.654,
    stopColor: "#747ca1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.758,
    stopColor: "#70789c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.853,
    stopColor: "#767da2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.989,
    stopColor: "#898eb3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8b90b5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-7",
    cx: 0.848,
    cy: 0.393,
    r: 0.418,
    gradientTransform: "matrix(-1.591, 0, 0, 1, 1676.369, 0)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b4299a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.119,
    stopColor: "#8a1f76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.259,
    stopColor: "#601552"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.402,
    stopColor: "#3d0e34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.547,
    stopColor: "#22071d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.694,
    stopColor: "#0f030d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.843,
    stopColor: "#030003"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 222.57,
    y1: -46.386,
    x2: 223.562,
    y2: -46.386,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.005,
    stopColor: "#ed5eb6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#f682c4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.253,
    stopColor: "#ffa3d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616,
    stopColor: "#dc5199"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.718,
    stopColor: "#de579d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.813,
    stopColor: "#e463a6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dc3d8f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 1.227,
    y1: 0.365,
    x2: -0.33,
    y2: 0.654,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.056,
    stopColor: "#ffa3d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.813,
    stopColor: "#e463a6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dc3d8f"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-8",
    cx: 0.866,
    cy: 0.441,
    r: 0.429,
    gradientTransform: "matrix(-1.459, 0, 0, 1, 1586.822, 0)",
    xlinkHref: "#radial-gradient-7"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-9",
    cx: 0.464,
    cy: -0.456,
    r: 1.505,
    gradientTransform: "translate(0.03) scale(0.94 1)",
    xlinkHref: "#radial-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 0.515,
    y1: 1.528,
    x2: 0.494,
    y2: 0.095,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9f79c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.137,
    stopColor: "#a47fca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.329,
    stopColor: "#b491d3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.553,
    stopColor: "#cdafe1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.581,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.764,
    stopColor: "#dac3e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ebdef3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 9.084,
    y1: 1.03,
    x2: 8.23,
    y2: 0.061,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 0.449,
    y1: 0.628,
    x2: 0.531,
    y2: 0.426,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    stopColor: "#45108a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7c1dc9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: 0.246,
    y1: 0.969,
    x2: 0.737,
    y2: 0.088,
    xlinkHref: "#linear-gradient-31"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: -3.539,
    y1: 0.492,
    x2: 16.148,
    y2: 0.531,
    xlinkHref: "#linear-gradient-29"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: 5.175,
    y1: 0.538,
    x2: -0.286,
    y2: 0.494,
    xlinkHref: "#linear-gradient-29"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: 0.187,
    y1: 0.917,
    x2: 0.747,
    y2: 0.171,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.035,
    stopColor: "#9f19ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.244,
    stopColor: "#ae24b0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.645,
    stopColor: "#d643bf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff63ce"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: 0.187,
    y1: 0.917,
    x2: 0.747,
    y2: 0.171,
    xlinkHref: "#linear-gradient-22"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: 0.187,
    y1: 0.917,
    x2: 0.747,
    y2: 0.171,
    xlinkHref: "#linear-gradient-29"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-10",
    cx: -0.327,
    cy: 0.566,
    r: 0.462,
    gradientTransform: "translate(-1.034) scale(3.068 1)",
    xlinkHref: "#radial-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#9f19ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.429,
    stopColor: "#5f27bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#3d065f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: -0.769,
    y1: -0.119,
    x2: 17.421,
    y2: 7.916,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: -6.271,
    y1: -1.971,
    x2: 15.286,
    y2: 6.056,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: -10.771,
    y1: -4.343,
    x2: 9.72,
    y2: 4.461,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    x1: -16.517,
    y1: -5.957,
    x2: 4.701,
    y2: 2.172,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-47",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient-35"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8577",
    "data-name": "Group 8577",
    transform: "translate(-312.398 -64.707)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8532",
    "data-name": "Group 8532",
    transform: "translate(312.398 64.707)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8530",
    "data-name": "Group 8530",
    transform: "translate(0 132.019)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13141",
    "data-name": "Path 13141",
    d: "M477.174,361.819a27.145,27.145,0,0,1-13.548-3.266L320.17,275.728c-4.94-2.852-7.773-7.366-7.772-12.382,0-5.5,3.411-10.622,9.359-14.055l81.414-47.005a33.355,33.355,0,0,1,16.451-4.181,27.138,27.138,0,0,1,13.547,3.265l143.458,82.825c4.939,2.853,7.772,7.365,7.772,12.382,0,5.5-3.411,10.621-9.359,14.055l-81.415,47.005A33.354,33.354,0,0,1,477.174,361.819Z",
    transform: "translate(-312.398 -198.105)",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13142",
    "data-name": "Path 13142",
    d: "M403.54,202.916a32.621,32.621,0,0,1,16.4-4.065,31.313,31.313,0,0,1,6.721.821,26.843,26.843,0,0,1,6.7,2.642l142.911,82.509c4.917,2.839,7.48,7.336,7.182,12.223A14.331,14.331,0,0,1,582.6,301c-1.246,3.492-4.783,7.211-8.8,9.53l-80.259,46.338a31.847,31.847,0,0,1-3.49,1.723,34.11,34.11,0,0,1-12.691,2.508A26.533,26.533,0,0,1,464,357.94L320.539,275.115c-4.929-2.845-7.478-7.357-7.155-12.249a14.658,14.658,0,0,1,.678-3.411c1.151-3.7,4.813-7.657,9.028-10.09Z",
    transform: "translate(-312.408 -198.113)",
    opacity: 0.091
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13143",
    "data-name": "Path 13143",
    d: "M403.909,203.545a31.911,31.911,0,0,1,16.355-3.947,27.844,27.844,0,0,1,13.3,3.661l142.366,82.2c4.893,2.825,7.193,7.3,6.592,12.065a15.823,15.823,0,0,1-1.062,3.772c-1.218,3.107-5.289,7.056-8.905,9.146l-79.1,45.67a35.868,35.868,0,0,1-3.429,1.717,33.615,33.615,0,0,1-12.482,2.563,25.946,25.946,0,0,1-13.175-3.061L320.907,274.5c-4.916-2.838-7.188-7.343-6.538-12.117a16.93,16.93,0,0,1,.867-3.253c1.145-3.295,5.392-7.5,9.186-9.693Z",
    transform: "translate(-312.417 -198.12)",
    opacity: 0.182
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13144",
    "data-name": "Path 13144",
    d: "M404.276,204.175a31.216,31.216,0,0,1,16.309-3.831A30.519,30.519,0,0,1,427.2,201.4a35.752,35.752,0,0,1,6.561,2.807l141.821,81.88c4.87,2.812,6.914,7.265,6,11.908a18.032,18.032,0,0,1-1.263,3.587c-1.17,2.726-5.793,6.9-9.007,8.761l-77.947,45c-.815.47-2.473,1.33-3.37,1.711a33.126,33.126,0,0,1-12.271,2.618,25.348,25.348,0,0,1-12.991-2.958L321.275,273.887c-4.9-2.831-6.908-7.324-5.921-11.985a20.53,20.53,0,0,1,1.057-3.1c1.117-2.892,5.971-7.349,9.342-9.3Z",
    transform: "translate(-312.426 -198.128)",
    opacity: 0.273
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13145",
    "data-name": "Path 13145",
    d: "M404.643,204.8a30.538,30.538,0,0,1,16.26-3.714,30.18,30.18,0,0,1,6.557,1.169,42.649,42.649,0,0,1,6.492,2.889l141.275,81.565c4.846,2.8,6.644,7.225,5.414,11.75a21.777,21.777,0,0,1-1.465,3.4c-1.1,2.349-6.3,6.751-9.11,8.375l-76.791,44.335c-.714.413-2.527,1.368-3.309,1.706a32.649,32.649,0,0,1-12.062,2.673A24.76,24.76,0,0,1,465.1,356.1L321.642,273.272c-4.892-2.823-6.638-7.3-5.3-11.851a27.163,27.163,0,0,1,1.245-2.938c1.068-2.494,6.55-7.2,9.5-8.9Z",
    transform: "translate(-312.434 -198.135)",
    opacity: 0.364
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13146",
    "data-name": "Path 13146",
    d: "M405.01,205.433a28.431,28.431,0,0,1,22.715-2.313,52,52,0,0,1,6.422,2.972l140.728,81.249c4.824,2.785,6.382,7.185,4.824,11.593a28.415,28.415,0,0,1-1.666,3.218c-1.012,1.98-6.8,6.6-9.213,7.989l-75.634,43.668c-.612.353-2.58,1.406-3.249,1.7a32.123,32.123,0,0,1-11.851,2.728,24.168,24.168,0,0,1-12.62-2.754L322.008,272.658c-4.879-2.817-6.376-7.281-4.686-11.72.359-.943.969-1.793,1.435-2.781.992-2.1,7.128-7.041,9.656-8.5Z",
    transform: "translate(-312.442 -198.143)",
    opacity: 0.455
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13147",
    "data-name": "Path 13147",
    d: "M405.376,206.062a27.483,27.483,0,0,1,22.613-2.079,65.4,65.4,0,0,1,6.353,3.053L574.524,287.97c4.8,2.772,6.131,7.147,4.233,11.436a12.47,12.47,0,0,1-1.866,3.034c-.573,1.763-7.307,6.443-9.316,7.6l-74.479,43c-.51.294-2.633,1.446-3.188,1.694a31.68,31.68,0,0,1-11.642,2.783,23.6,23.6,0,0,1-12.435-2.652L322.375,272.044c-4.867-2.81-6.129-7.262-4.069-11.587a12.74,12.74,0,0,1,1.624-2.624c.519-1.867,7.707-6.888,9.815-8.1Z",
    transform: "translate(-312.449 -198.151)",
    opacity: 0.545
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13148",
    "data-name": "Path 13148",
    d: "M405.742,206.691a26.608,26.608,0,0,1,22.511-1.847c.883.284,5.556,2.717,6.281,3.136L574.172,288.6c4.777,2.758,5.891,7.114,3.644,11.277a12.686,12.686,0,0,1-2.067,2.851c-.458,1.41-7.811,6.288-9.419,7.217l-73.323,42.334c-.407.235-2.684,1.487-3.127,1.688a31.167,31.167,0,0,1-11.433,2.837,23.023,23.023,0,0,1-12.249-2.549L322.741,271.43c-4.855-2.8-5.892-7.25-3.453-11.454a12.989,12.989,0,0,1,1.814-2.466c.414-1.493,8.284-6.735,9.971-7.708Z",
    transform: "translate(-312.456 -198.158)",
    opacity: 0.636
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13149",
    "data-name": "Path 13149",
    d: "M406.108,207.32a27.976,27.976,0,0,1,16.07-3.245,28.435,28.435,0,0,1,6.338,1.631c.659.223,5.668,2.9,6.212,3.218l139.091,80.305c4.754,2.744,5.661,7.088,3.054,11.119a12.974,12.974,0,0,1-2.268,2.666c-.343,1.058-8.315,6.136-9.521,6.832l-72.167,41.666c-.306.177-2.735,1.53-3.067,1.683a30.694,30.694,0,0,1-11.223,2.893,22.456,22.456,0,0,1-12.064-2.447L323.105,270.816c-4.842-2.8-5.665-7.247-2.835-11.323a13.421,13.421,0,0,1,2-2.308c.311-1.12,8.863-6.58,10.128-7.311Z",
    transform: "translate(-312.463 -198.165)",
    opacity: 0.727
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13150",
    "data-name": "Path 13150",
    d: "M406.472,207.95a27.36,27.36,0,0,1,16.023-3.128,27.93,27.93,0,0,1,6.283,1.747c.437.154,5.78,3.091,6.143,3.3l138.546,79.99c4.731,2.73,5.438,7.073,2.463,10.962a13.467,13.467,0,0,1-2.469,2.482c-.229.706-8.82,5.983-9.623,6.447l-71.011,41c-.2.118-2.786,1.574-3.007,1.677a30.215,30.215,0,0,1-11.013,2.947,21.889,21.889,0,0,1-11.879-2.345L323.471,270.2c-4.831-2.79-5.447-7.255-2.218-11.19a13.889,13.889,0,0,1,2.192-2.151c.207-.747,9.442-6.427,10.285-6.914Z",
    transform: "translate(-312.469 -198.173)",
    opacity: 0.818
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13151",
    "data-name": "Path 13151",
    d: "M406.837,208.579a26.777,26.777,0,0,1,15.975-3.012,27.478,27.478,0,0,1,6.229,1.863c.218.08,5.891,3.278,6.073,3.383l138,79.675c4.707,2.718,5.223,7.069,1.875,10.8a14.152,14.152,0,0,1-2.67,2.3c-.115.352-9.325,5.828-9.726,6.061l-69.855,40.331c-.1.058-2.837,1.619-2.946,1.672a29.733,29.733,0,0,1-10.8,3c-4.353.272-8.613-.465-11.693-2.244L323.836,269.586c-4.819-2.782-5.234-7.274-1.6-11.057a14.526,14.526,0,0,1,2.381-1.993c.1-.374,10.021-6.273,10.443-6.517Z",
    transform: "translate(-312.475 -198.18)",
    opacity: 0.909
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13152",
    "data-name": "Path 13152",
    d: "M467.657,351.8,324.2,268.972c-5.665-3.271-4.954-8.983,1.587-12.76L407.2,209.207c6.541-3.777,16.436-4.187,22.1-.916L572.76,291.116c5.666,3.271,4.955,8.984-1.586,12.761l-81.415,47C483.217,354.658,473.323,355.068,467.657,351.8Z",
    transform: "translate(-312.48 -198.187)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_13153",
    "data-name": "Path 13153",
    d: "M467.657,351.664,324.2,268.839c-2.524-1.457-3.783-3.4-3.823-5.44,0-.065,0-7.04,0-7.107.046-2.479,1.877,1.827,5.41-.213L407.2,209.074c6.541-3.777,16.436-4.187,22.1-.916L572.76,290.983c1.891,1.092,3.263-3.542,3.754-2.069.163.491.059,6.993.07,7.5.053,2.54-1.78,5.232-5.41,7.328l-81.415,47C483.217,354.525,473.323,354.935,467.657,351.664Z",
    transform: "translate(-312.48 -66.167)",
    fill: "url(#linear-gradient)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13154",
    "data-name": "Path 13154",
    d: "M467.657,344.616,324.2,261.792c-5.665-3.271-4.954-8.984,1.587-12.761L407.2,202.026c6.541-3.777,16.436-4.187,22.1-.916L572.76,283.935c5.666,3.271,4.955,8.984-1.586,12.761L489.759,343.7C483.217,347.477,473.323,347.887,467.657,344.616Z",
    transform: "translate(-312.48 -66.094)",
    fill: "url(#linear-gradient-2)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13155",
    "data-name": "Path 13155",
    d: "M477.287,343.99a16.745,16.745,0,0,1-8.167-1.824L325.663,259.341c-.894-.516-2.392-1.6-2.392-3.061,0-1.528,1.486-3.3,3.979-4.737l81.414-47.006a22.791,22.791,0,0,1,11.07-2.74,16.745,16.745,0,0,1,8.167,1.824l143.457,82.825c.894.516,2.391,1.6,2.391,3.061,0,1.528-1.487,3.3-3.978,4.738L488.356,341.25A22.773,22.773,0,0,1,477.287,343.99Z",
    transform: "translate(-312.51 -66.124)",
    fill: "url(#linear-gradient-3)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13156",
    "data-name": "Path 13156",
    d: "M571.174,296.1l-81.415,47.005c-6.542,3.777-16.436,4.186-22.1.916L324.2,261.2c-2.349-1.357-3.587-3.136-3.78-5.021-.294,2.314.942,4.566,3.78,6.205l143.457,82.824c5.666,3.271,15.56,2.861,22.1-.915l81.415-47.005c3.828-2.21,5.642-5.081,5.368-7.74C576.249,291.852,574.438,294.219,571.174,296.1Z",
    transform: "translate(-312.48 -66.686)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_202",
    "data-name": "Ellipse 202",
    cx: 35.812,
    cy: 21.146,
    rx: 35.812,
    ry: 21.146,
    transform: "matrix(0.946, -0.325, 0.325, 0.946, 50.745, 157.376)",
    fill: "url(#radial-gradient)",
    style: {
      mixBlendMode: "color-dodge",
      isolation: "isolate"
    }
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13157",
    "data-name": "Path 13157",
    d: "M493.722,314.276,377.229,247.018c-2.333-1.347-2.041-3.7.653-5.254l43.737-25.251c2.693-1.556,6.767-1.724,9.1-.377l116.494,67.258c2.333,1.347,2.04,3.7-.653,5.254L502.823,313.9C500.129,315.454,496.055,315.622,493.722,314.276Z",
    transform: "translate(-313.052 -66.263)",
    fill: "url(#linear-gradient-4)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_13158",
    "data-name": "Path 13158",
    d: "M424.24,221.467l7.465,4.309a3.788,3.788,0,0,0,3.427.007,1.045,1.045,0,0,0-.011-1.979l-7.465-4.31a3.791,3.791,0,0,0-3.427-.006A1.045,1.045,0,0,0,424.24,221.467Zm12.782,7.379,3.536,2.042a3.788,3.788,0,0,0,3.427.006,1.044,1.044,0,0,0-.011-1.978l-3.536-2.042a3.785,3.785,0,0,0-3.427-.006A1.044,1.044,0,0,0,437.022,228.846Zm8.853,5.111L449.41,236a3.785,3.785,0,0,0,3.427.006,1.044,1.044,0,0,0-.011-1.978l-3.536-2.042a3.788,3.788,0,0,0-3.427-.006A1.044,1.044,0,0,0,445.874,233.957Zm8.853,5.112,3.536,2.042a3.789,3.789,0,0,0,3.426.006,1.045,1.045,0,0,0-.01-1.979l-3.536-2.042a3.791,3.791,0,0,0-3.427-.006A1.045,1.045,0,0,0,454.727,239.068Zm8.852,5.111,3.536,2.042a3.788,3.788,0,0,0,3.427.006,1.044,1.044,0,0,0-.01-1.978L467,242.206a3.785,3.785,0,0,0-3.427-.006A1.044,1.044,0,0,0,463.578,244.179Zm8.853,5.111,3.536,2.042a3.785,3.785,0,0,0,3.427.006,1.044,1.044,0,0,0-.011-1.978l-3.536-2.042a3.786,3.786,0,0,0-3.426-.006A1.044,1.044,0,0,0,472.431,249.29Zm8.853,5.112,3.536,2.042a3.791,3.791,0,0,0,3.427.006,1.044,1.044,0,0,0-.011-1.978l-3.536-2.042a3.788,3.788,0,0,0-3.427-.007A1.045,1.045,0,0,0,481.283,254.4Zm8.853,5.111,3.536,2.042a3.785,3.785,0,0,0,3.427.006,1.044,1.044,0,0,0-.011-1.978l-3.536-2.042a3.785,3.785,0,0,0-3.427-.006A1.044,1.044,0,0,0,490.136,259.512Zm8.852,5.111,3.536,2.042a3.785,3.785,0,0,0,3.427.006,1.044,1.044,0,0,0-.011-1.978L502.4,262.65a3.789,3.789,0,0,0-3.427-.006A1.044,1.044,0,0,0,498.988,264.622Zm8.853,5.112,3.536,2.042a3.791,3.791,0,0,0,3.427.006,1.044,1.044,0,0,0-.011-1.978l-3.536-2.042a3.788,3.788,0,0,0-3.427-.007A1.045,1.045,0,0,0,507.841,269.734Zm8.853,5.111,3.536,2.042a3.785,3.785,0,0,0,3.427.006,1.044,1.044,0,0,0-.011-1.978l-3.536-2.042a3.785,3.785,0,0,0-3.427-.006A1.044,1.044,0,0,0,516.693,274.845Zm8.853,5.111L529.082,282a3.785,3.785,0,0,0,3.427.006,1.044,1.044,0,0,0-.011-1.978l-3.536-2.042a3.792,3.792,0,0,0-3.427-.006A1.044,1.044,0,0,0,525.546,279.955Zm9.037,5.218,3.536,2.042a3.785,3.785,0,0,0,3.427.006,1.044,1.044,0,0,0-.011-1.978L538,283.2a3.788,3.788,0,0,0-3.427-.006A1.044,1.044,0,0,0,534.583,285.173Zm-118.3-58.836,3.061,1.768a4.309,4.309,0,0,0,3.9.007l3.042-1.756a1.189,1.189,0,0,0-.012-2.252l-3.062-1.768a4.313,4.313,0,0,0-3.9-.007l-3.042,1.757A1.188,1.188,0,0,0,416.278,226.337Zm15.814,6.886,3.042-1.757a1.189,1.189,0,0,0-.012-2.252l-3.062-1.767a4.31,4.31,0,0,0-3.9-.008l-3.042,1.757a1.189,1.189,0,0,0,.013,2.252l3.061,1.767A4.309,4.309,0,0,0,432.092,233.223Zm1.891,3.336,3.061,1.768a4.312,4.312,0,0,0,3.9.007l3.042-1.757a1.188,1.188,0,0,0-.012-2.251l-3.062-1.768a4.309,4.309,0,0,0-3.9-.007l-3.042,1.757A1.188,1.188,0,0,0,433.983,236.559Zm8.852,5.111,3.062,1.768a4.306,4.306,0,0,0,3.9.007l3.042-1.756a1.189,1.189,0,0,0-.013-2.252l-3.061-1.768a4.312,4.312,0,0,0-3.9-.007l-3.042,1.757A1.188,1.188,0,0,0,442.835,241.67Zm18.844,2.878-3.061-1.768a4.306,4.306,0,0,0-3.9-.007l-3.042,1.756a1.189,1.189,0,0,0,.012,2.252l3.062,1.768a4.312,4.312,0,0,0,3.9.007l3.042-1.757A1.188,1.188,0,0,0,461.679,244.548Zm8.853,5.111-3.061-1.768a4.309,4.309,0,0,0-3.9-.007l-3.042,1.757a1.188,1.188,0,0,0,.012,2.251l3.062,1.768a4.312,4.312,0,0,0,3.9.007l3.042-1.757A1.188,1.188,0,0,0,470.532,249.659Zm8.853,5.111L476.323,253a4.312,4.312,0,0,0-3.9-.007l-3.042,1.757a1.188,1.188,0,0,0,.012,2.251l3.061,1.768a4.308,4.308,0,0,0,3.9.007l3.042-1.756A1.189,1.189,0,0,0,479.384,254.769Zm8.853,5.112-3.061-1.768a4.306,4.306,0,0,0-3.9-.007l-3.042,1.756a1.189,1.189,0,0,0,.012,2.252l3.061,1.768a4.312,4.312,0,0,0,3.9.007l3.042-1.757A1.188,1.188,0,0,0,488.237,259.881Zm8.853,5.111-3.061-1.768a4.309,4.309,0,0,0-3.9-.007l-3.042,1.757a1.188,1.188,0,0,0,.012,2.251l3.061,1.768a4.313,4.313,0,0,0,3.9.007l3.042-1.757A1.188,1.188,0,0,0,497.089,264.992Zm8.853,5.111-3.061-1.768a4.313,4.313,0,0,0-3.9-.007l-3.042,1.757a1.188,1.188,0,0,0,.012,2.251l3.061,1.768a4.306,4.306,0,0,0,3.9.007l3.042-1.756A1.189,1.189,0,0,0,505.942,270.1Zm-1.139,7.345,3.061,1.768a4.312,4.312,0,0,0,3.9.007l3.042-1.757a1.188,1.188,0,0,0-.012-2.251l-3.061-1.768a4.308,4.308,0,0,0-3.9-.007L504.79,275.2A1.189,1.189,0,0,0,504.8,277.447Zm18.844,2.877-3.062-1.768a4.312,4.312,0,0,0-3.9-.007l-3.042,1.757a1.188,1.188,0,0,0,.013,2.251l3.061,1.768a4.313,4.313,0,0,0,3.9.007l3.042-1.757A1.188,1.188,0,0,0,523.647,280.324Zm12.966,7.486-6.991-4.036a4.306,4.306,0,0,0-3.9-.007l-3.042,1.757a1.188,1.188,0,0,0,.013,2.251l6.99,4.036a4.312,4.312,0,0,0,3.9.007l3.042-1.757A1.188,1.188,0,0,0,536.612,287.81ZM408.079,231.072l6.99,4.036a4.312,4.312,0,0,0,3.9.007l3.042-1.757a1.188,1.188,0,0,0-.012-2.251l-6.991-4.036a4.309,4.309,0,0,0-3.9-.008l-3.042,1.757A1.189,1.189,0,0,0,408.079,231.072Zm12.782,7.379,3.061,1.768a4.312,4.312,0,0,0,3.9.007l3.042-1.757a1.188,1.188,0,0,0-.012-2.252l-3.062-1.768a4.312,4.312,0,0,0-3.9-.007l-3.042,1.757A1.188,1.188,0,0,0,420.86,238.451Zm11.914,6.878a4.306,4.306,0,0,0,3.9.007l3.042-1.756a1.189,1.189,0,0,0-.012-2.252l-3.062-1.768a4.313,4.313,0,0,0-3.9-.007L429.7,241.31a1.188,1.188,0,0,0,.013,2.251Zm8.853,5.112a4.313,4.313,0,0,0,3.9.007l3.042-1.757a1.188,1.188,0,0,0-.012-2.251l-3.062-1.768a4.306,4.306,0,0,0-3.9-.007l-3.042,1.756a1.189,1.189,0,0,0,.012,2.252Zm8.821-.665-3.042,1.757a1.188,1.188,0,0,0,.012,2.251l3.062,1.768a4.309,4.309,0,0,0,3.9.007l3.042-1.757a1.188,1.188,0,0,0-.013-2.251l-3.061-1.768A4.309,4.309,0,0,0,450.447,249.775Zm9.04,5-3.416,1.972a1.074,1.074,0,0,0,.011,2.036l3.438,1.984a3.9,3.9,0,0,0,3.525.007l3.416-1.973a1.074,1.074,0,0,0-.011-2.035l-3.438-1.985A3.9,3.9,0,0,0,459.487,254.778Zm8.853,5.112-3.416,1.971a1.074,1.074,0,0,0,.011,2.036l3.438,1.985a3.9,3.9,0,0,0,3.525.006l3.416-1.972a1.075,1.075,0,0,0-.012-2.036l-3.437-1.984A3.892,3.892,0,0,0,468.339,259.89ZM477.192,265l-3.416,1.972a1.074,1.074,0,0,0,.011,2.035l3.438,1.985a3.9,3.9,0,0,0,3.524.006l3.417-1.972a1.074,1.074,0,0,0-.012-2.035l-3.437-1.985A3.9,3.9,0,0,0,477.192,265Zm8.853,5.111-3.416,1.972a1.074,1.074,0,0,0,.011,2.036l3.438,1.984a3.893,3.893,0,0,0,3.524.007l3.416-1.972a1.074,1.074,0,0,0-.011-2.036l-3.437-1.984A3.9,3.9,0,0,0,486.045,270.111Zm8.853,5.111-3.416,1.972a1.074,1.074,0,0,0,.011,2.036l3.437,1.985a3.9,3.9,0,0,0,3.525.006l3.416-1.972a1.074,1.074,0,0,0-.011-2.036l-3.438-1.984A3.893,3.893,0,0,0,494.9,275.222Zm12.409,11.11,3.416-1.972a1.074,1.074,0,0,0-.011-2.035l-3.438-1.985a3.9,3.9,0,0,0-3.524-.006l-3.417,1.972a1.074,1.074,0,0,0,.012,2.035l3.437,1.985A3.9,3.9,0,0,0,507.307,286.332Zm8.853,5.112,3.416-1.972a1.075,1.075,0,0,0-.011-2.036l-3.438-1.984a3.9,3.9,0,0,0-3.525-.007l-3.416,1.972a1.075,1.075,0,0,0,.012,2.036l3.437,1.984A3.9,3.9,0,0,0,516.159,291.443Zm12.442,1.209-3.438-1.985a3.9,3.9,0,0,0-3.525-.006l-3.416,1.972a1.075,1.075,0,0,0,.012,2.036l3.437,1.984a3.892,3.892,0,0,0,3.525.006l3.416-1.972A1.074,1.074,0,0,0,528.6,292.653ZM399.691,235.7l11.1,6.408a3.9,3.9,0,0,0,3.525.007l3.416-1.972a1.075,1.075,0,0,0-.011-2.036l-11.1-6.408a3.892,3.892,0,0,0-3.525-.006l-3.416,1.972A1.074,1.074,0,0,0,399.691,235.7Zm16.514,9.534,3.438,1.985a3.9,3.9,0,0,0,3.525.006l3.416-1.972a1.074,1.074,0,0,0-.012-2.035l-3.437-1.985a3.9,3.9,0,0,0-3.525-.007l-3.416,1.973A1.074,1.074,0,0,0,416.2,245.231Zm8.853,5.111,3.438,1.985a3.893,3.893,0,0,0,3.524.006l3.417-1.972a1.074,1.074,0,0,0-.012-2.035l-3.437-1.985a3.9,3.9,0,0,0-3.525-.006l-3.416,1.972A1.074,1.074,0,0,0,425.058,250.342Zm8.853,5.112,3.438,1.984a3.893,3.893,0,0,0,3.524.007l3.416-1.972a1.074,1.074,0,0,0-.011-2.036l-3.437-1.984a3.9,3.9,0,0,0-3.525-.007l-3.416,1.972A1.074,1.074,0,0,0,433.91,255.453Zm15.815,7.1,3.416-1.972a1.074,1.074,0,0,0-.011-2.035l-3.438-1.985a3.89,3.89,0,0,0-3.524-.006l-3.416,1.972a1.074,1.074,0,0,0,.011,2.035l3.437,1.985A3.9,3.9,0,0,0,449.725,262.555Zm8.853,5.111,3.416-1.972a1.074,1.074,0,0,0-.011-2.035l-3.438-1.985a3.9,3.9,0,0,0-3.525-.006L451.6,263.64a1.074,1.074,0,0,0,.012,2.035l3.437,1.985A3.9,3.9,0,0,0,458.577,267.666Zm8.853,5.112,3.416-1.972a1.074,1.074,0,0,0-.011-2.036l-3.438-1.984a3.9,3.9,0,0,0-3.525-.007l-3.416,1.972a1.075,1.075,0,0,0,.011,2.036l3.438,1.984A3.9,3.9,0,0,0,467.43,272.777Zm8.853,5.111,3.416-1.972a1.074,1.074,0,0,0-.011-2.035L476.25,271.9a3.892,3.892,0,0,0-3.525-.006l-3.416,1.972a1.074,1.074,0,0,0,.011,2.035l3.438,1.985A3.9,3.9,0,0,0,476.283,277.888ZM485.135,283l3.416-1.972a1.074,1.074,0,0,0-.011-2.035l-3.438-1.985a3.9,3.9,0,0,0-3.525-.006l-3.416,1.972a1.074,1.074,0,0,0,.011,2.035l3.438,1.985A3.892,3.892,0,0,0,485.135,283Zm8.853,5.112,3.416-1.972a1.075,1.075,0,0,0-.011-2.036l-3.438-1.984a3.9,3.9,0,0,0-3.525-.007l-3.416,1.972a1.075,1.075,0,0,0,.011,2.036l3.438,1.984A3.9,3.9,0,0,0,493.988,288.11Zm1.889,3.119,3.438,1.985a3.9,3.9,0,0,0,3.525.006l3.416-1.972a1.074,1.074,0,0,0-.011-2.035l-3.438-1.985a3.9,3.9,0,0,0-3.525-.006l-3.416,1.972A1.074,1.074,0,0,0,495.877,291.229Zm24.525,6.157-8.742-5.047a3.9,3.9,0,0,0-3.525-.006l-3.416,1.972a1.074,1.074,0,0,0,.011,2.035l8.742,5.047a3.9,3.9,0,0,0,3.525.007l3.416-1.972A1.074,1.074,0,0,0,520.4,297.386ZM391.526,240.675l15.749,9.092a4.4,4.4,0,0,0,3.982.008l2.96-1.71a1.214,1.214,0,0,0-.012-2.3l-15.749-9.092a4.4,4.4,0,0,0-3.982-.007l-2.961,1.709A1.214,1.214,0,0,0,391.526,240.675Zm21.621,12.484,2.98,1.72a4.4,4.4,0,0,0,3.981.007l2.961-1.709a1.213,1.213,0,0,0-.012-2.3l-2.98-1.72a4.4,4.4,0,0,0-3.982-.008l-2.96,1.71A1.214,1.214,0,0,0,413.147,253.159ZM422,258.27l2.98,1.72a4.4,4.4,0,0,0,3.981.007l2.961-1.709a1.214,1.214,0,0,0-.012-2.3l-2.98-1.72a4.4,4.4,0,0,0-3.982-.007l-2.96,1.709A1.214,1.214,0,0,0,422,258.27Zm8.853,5.111,2.98,1.721a4.4,4.4,0,0,0,3.981.007l2.961-1.709a1.214,1.214,0,0,0-.013-2.3l-2.979-1.72a4.4,4.4,0,0,0-3.982-.007l-2.96,1.709A1.213,1.213,0,0,0,430.852,263.38Zm8.853,5.112,2.98,1.72a4.4,4.4,0,0,0,3.981.007l2.961-1.709a1.213,1.213,0,0,0-.013-2.3l-2.979-1.72a4.4,4.4,0,0,0-3.982-.008l-2.961,1.71A1.214,1.214,0,0,0,439.7,268.492Zm8.853,5.111,2.98,1.72a4.4,4.4,0,0,0,3.981.007l2.961-1.709a1.214,1.214,0,0,0-.013-2.3l-2.979-1.72a4.4,4.4,0,0,0-3.982-.007l-2.961,1.709A1.213,1.213,0,0,0,448.557,273.6Zm8.853,5.111,2.979,1.721a4.4,4.4,0,0,0,3.982.007l2.961-1.71a1.214,1.214,0,0,0-.013-2.3l-2.979-1.72a4.4,4.4,0,0,0-3.982-.007l-2.961,1.709A1.214,1.214,0,0,0,457.41,278.713Zm8.853,5.112,2.979,1.72a4.4,4.4,0,0,0,3.982.007l2.961-1.709a1.213,1.213,0,0,0-.013-2.3l-2.979-1.72a4.4,4.4,0,0,0-3.982-.008l-2.961,1.71A1.214,1.214,0,0,0,466.262,283.825Zm8.853,5.111,2.979,1.72a4.4,4.4,0,0,0,3.982.007l2.961-1.709a1.214,1.214,0,0,0-.013-2.3l-2.98-1.72a4.4,4.4,0,0,0-3.981-.007l-2.961,1.709A1.213,1.213,0,0,0,475.115,288.935Zm8.853,5.111,2.979,1.721a4.4,4.4,0,0,0,3.982.007l2.961-1.71a1.214,1.214,0,0,0-.013-2.3l-2.98-1.72a4.4,4.4,0,0,0-3.981-.007l-2.961,1.709A1.213,1.213,0,0,0,483.967,294.046Zm8.852,5.112,2.98,1.72a4.4,4.4,0,0,0,3.982.007l2.96-1.709a1.214,1.214,0,0,0-.012-2.3l-2.98-1.72a4.4,4.4,0,0,0-3.981-.008l-2.961,1.71A1.214,1.214,0,0,0,492.819,299.158Zm18.959,2.943-2.979-1.72a4.4,4.4,0,0,0-3.982-.008l-2.961,1.71a1.214,1.214,0,0,0,.013,2.3l2.979,1.72a4.4,4.4,0,0,0,3.982.007l2.961-1.709A1.214,1.214,0,0,0,511.778,302.1ZM397.165,245.4l-6.908-3.989a4.4,4.4,0,0,0-3.982-.007l-2.961,1.709a1.214,1.214,0,0,0,.013,2.3l6.908,3.989a4.4,4.4,0,0,0,3.982.007l2.961-1.709A1.214,1.214,0,0,0,397.165,245.4Zm8.853,5.111-2.979-1.72a4.4,4.4,0,0,0-3.982-.007l-2.961,1.709a1.214,1.214,0,0,0,.013,2.3l2.979,1.72a4.4,4.4,0,0,0,3.982.007l2.961-1.709A1.214,1.214,0,0,0,406.017,250.508Zm8.853,5.111-2.979-1.72a4.4,4.4,0,0,0-3.982-.007l-2.961,1.709a1.214,1.214,0,0,0,.013,2.3l2.979,1.72a4.4,4.4,0,0,0,3.982.008l2.961-1.71A1.214,1.214,0,0,0,414.87,255.618ZM476.837,291.4l-56.094-32.387a4.4,4.4,0,0,0-3.981-.007l-2.961,1.71a1.213,1.213,0,0,0,.013,2.3L469.907,295.4a4.4,4.4,0,0,0,3.981.007l2.961-1.709A1.213,1.213,0,0,0,476.837,291.4Zm8.853,5.111-2.979-1.72a4.4,4.4,0,0,0-3.982-.007l-2.961,1.709a1.214,1.214,0,0,0,.013,2.3l2.98,1.72a4.4,4.4,0,0,0,3.981.007l2.961-1.709A1.213,1.213,0,0,0,485.689,296.506Zm8.853,5.111-2.979-1.72a4.4,4.4,0,0,0-3.982-.007l-2.961,1.709a1.213,1.213,0,0,0,.013,2.3l2.98,1.72a4.4,4.4,0,0,0,3.981.008l2.961-1.71A1.213,1.213,0,0,0,494.542,301.617Zm9.037,5.218-2.979-1.72a4.4,4.4,0,0,0-3.982-.007l-2.961,1.709a1.213,1.213,0,0,0,.013,2.3l2.98,1.72a4.4,4.4,0,0,0,3.982.007l2.961-1.709A1.213,1.213,0,0,0,503.578,306.835Z",
    transform: "translate(-313.122 -66.302)",
    opacity: 0.3,
    fill: "url(#linear-gradient-5)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8531",
    "data-name": "Group 8531",
    transform: "translate(110.096)"
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13159",
    "data-name": "Path 13159",
    d: "M571.554,281.463,433.333,201.614c-5.351-3.089-9.689-11.378-9.689-18.513V74.668c0-7.134,4.338-10.414,9.689-7.325l138.222,79.849c5.352,3.09,9.69,11.378,9.69,18.514V274.138C581.244,281.274,576.906,284.552,571.554,281.463Z",
    transform: "translate(-423.644 -64.722)",
    fill: "url(#linear-gradient-6)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13160",
    "data-name": "Path 13160",
    d: "M572.859,275.955,436.112,196.967c-4.306-2.736-6.969-8.205-6.969-13.8V74.208a1.717,1.717,0,0,1,2.586-1.48l.3.176L568.89,151.97c5.127,2.955,6.969,8.205,6.969,13.8v108.7a1.854,1.854,0,0,1-2.773,1.609Z",
    transform: "translate(-423.701 -64.787)",
    fill: "url(#linear-gradient-7)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_13161",
    "data-name": "Path 13161",
    d: "M568.89,151.97,432.033,72.9l-.3-.176a1.717,1.717,0,0,0-2.586,1.48V183.165c0,5.6,2.663,11.065,6.969,13.8l136.747,78.988.227.13a1.854,1.854,0,0,0,2.773-1.609v-108.7C575.859,160.175,574.016,154.925,568.89,151.97Zm5.881,122.506a.769.769,0,0,1-.769.767.753.753,0,0,1-.376-.1L436.657,196.025c-3.889-2.472-6.427-7.529-6.427-12.86V74.208a.633.633,0,0,1,.633-.629.618.618,0,0,1,.316.089l137.165,79.244c5.312,3.061,6.426,8.682,6.426,12.86Z",
    transform: "translate(-423.701 -64.787)",
    fill: "#bcbec0",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13162",
    "data-name": "Path 13162",
    d: "M574.339,145.719,436.117,65.87a6.549,6.549,0,0,0-5.67-.832c-.2.078-2.9,1.513-3.095,1.619l-.009.006c1.651-.8,3.745-.652,6.027.666l138.221,79.849c5.352,3.09,9.69,11.378,9.69,18.514V274.123c0,4.452-1.69,7.4-4.262,8.242a1.605,1.605,0,0,0,.849-.289c.123-.07,3.055-1.725,3.172-1.807,1.841-1.289,2.987-3.938,2.987-7.6V164.232C584.029,157.1,579.69,148.809,574.339,145.719Z",
    transform: "translate(-423.682 -64.707)",
    fill: "url(#linear-gradient-8)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_13163",
    "data-name": "Path 13163",
    d: "M572.064,146.958,433.843,67.109c-2.194-1.267-4.211-1.448-5.836-.746a7.158,7.158,0,0,1,4.674,1.095L570.9,147.307c5.351,3.089,9.689,11.378,9.689,18.513V274.252c0,4.21-1.516,7.061-3.853,8.072,2.989-.474,5.016-3.545,5.016-8.42V165.472C581.754,158.336,577.416,150.048,572.064,146.958Z",
    transform: "translate(-423.689 -64.72)",
    fill: "url(#radial-gradient-2)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_13164",
    "data-name": "Path 13164",
    d: "M548.9,161.49l-98.318-55.867c-.25,13.087-.024,54.1-.1,67.5-.118,21.7-3.365,38.788-28.413,58.394-7.97,6.239-43.136,25.4-71.669,40.389-11.576,6.083-12.455,8.65-18.309,13.608-5.673,4.806-14.374,9.272-16.919,10.756l97.667,56.474c1.825-1.083,11.327-5.849,17.567-11.134,5.854-4.958,6.733-10.246,18.309-16.329,28.534-14.994,77.421-45.018,86.1-50.225,11.134-6.68,13.982-10.886,13.982-28.453C548.794,233.124,548.638,174.336,548.9,161.49Z",
    transform: "translate(-0.029 -0.423)",
    fill: "#231f20",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13165",
    "data-name": "Path 13165",
    d: "M548.91,154.99,450.592,99.123c-.25,13.087-.024,66.275-.1,79.675-.118,21.7-3.365,26.61-28.413,46.216-7.97,6.239-43.136,25.4-71.669,40.389-11.576,6.083-13.445,13.845-19.3,18.8-5.673,4.806-11.963,6.12-14.508,7.6l97.666,56.475c1.826-1.083,8.916-2.7,15.156-7.982,5.854-4.958,7.722-12.72,19.3-18.8,28.534-14.994,63.7-34.151,71.67-40.389,25.048-19.606,28.294-24.519,28.413-46.217C548.882,221.419,548.653,167.836,548.91,154.99Z",
    transform: "translate(-0.043 -0.356)",
    fill: "url(#linear-gradient-9)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_8560",
    "data-name": "Group 8560",
    transform: "translate(355.829 217.841)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8541",
    "data-name": "Group 8541",
    transform: "translate(70.308 13.882)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8533",
    "data-name": "Group 8533",
    transform: "translate(5.414 1.948)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13166",
    "data-name": "Path 13166",
    d: "M439.831,243.889a.416.416,0,0,1-.209-.056L433,240.011a.416.416,0,0,1,0-.721l6.576-3.8a.415.415,0,0,1,.418,0l6.618,3.82a.417.417,0,0,1,0,.722l-6.577,3.8A.414.414,0,0,1,439.831,243.889Zm-5.783-4.238,5.783,3.338,5.743-3.314-5.784-3.339Z",
    transform: "translate(-432.796 -235.436)",
    fill: "#b086cc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8534",
    "data-name": "Group 8534"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13167",
    "data-name": "Path 13167",
    d: "M427.325,235.1a.1.1,0,0,1,.059-.078l.07-.027,5.749-1.51a.519.519,0,0,1,.4.042l.719.415c.113.065.137.142.072.23l-2.618,3.318-.045.042a.275.275,0,0,1-.14.032.28.28,0,0,1-.134-.033l-.581-.335c-.091-.053-.112-.113-.065-.181l.483-.626-1.929-1.115-1.087.28a.409.409,0,0,1-.313-.039l-.58-.335A.1.1,0,0,1,427.325,235.1Zm3.018-.13,1.476.852,1.259-1.58Z",
    transform: "translate(-427.325 -233.467)",
    fill: "url(#linear-gradient-10)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8535",
    "data-name": "Group 8535",
    transform: "translate(25.616 13.612)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13168",
    "data-name": "Path 13168",
    d: "M460.245,255.675a.414.414,0,0,1-.209-.056l-6.618-3.821a.417.417,0,0,1,0-.722l6.576-3.8a.415.415,0,0,1,.418,0l6.618,3.822a.417.417,0,0,1,0,.722l-6.576,3.8A.417.417,0,0,1,460.245,255.675Zm-5.784-4.239,5.784,3.339,5.741-3.314-5.783-3.34Z",
    transform: "translate(-453.209 -247.221)",
    fill: "#b086cc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8536",
    "data-name": "Group 8536",
    transform: "translate(20.634 10.969)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13169",
    "data-name": "Path 13169",
    d: "M448.175,247.122a.1.1,0,0,1,.062-.091l4.221-2.437a.337.337,0,0,1,.16-.044.3.3,0,0,1,.159.041l1.893,1.093c.51.294.777.578.808.852s-.148.523-.533.744a1.8,1.8,0,0,1-.74.236,2.367,2.367,0,0,1-.728-.028.545.545,0,0,1,.061.5.909.909,0,0,1-.446.476,2.551,2.551,0,0,1-1.384.325,3.205,3.205,0,0,1-1.518-.449l-1.952-1.127A.1.1,0,0,1,448.175,247.122Zm2.6.751a1.429,1.429,0,0,0,.714.2,1.276,1.276,0,0,0,.659-.163c.19-.109.284-.237.277-.383s-.117-.28-.34-.409l-1.076-.622-1.311.756Zm1.919-1.183a1.419,1.419,0,0,0,.675.2,1.129,1.129,0,0,0,.614-.146c.182-.1.263-.22.246-.345s-.143-.253-.367-.384l-1.011-.583-1.168.673Z",
    transform: "translate(-448.175 -244.551)",
    fill: "url(#linear-gradient-11)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8537",
    "data-name": "Group 8537",
    transform: "translate(45.296 24.975)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13170",
    "data-name": "Path 13170",
    d: "M480.13,267.156a.416.416,0,0,1-.209-.056l-6.618-3.821a.417.417,0,0,1,0-.722l6.576-3.8a.414.414,0,0,1,.418,0l6.618,3.82a.417.417,0,0,1,0,.722l-6.576,3.8A.414.414,0,0,1,480.13,267.156Zm-5.783-4.239,5.783,3.339,5.742-3.315-5.784-3.339Z",
    transform: "translate(-473.094 -258.703)",
    fill: "#b086cc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8538",
    "data-name": "Group 8538",
    transform: "translate(40.982 22.726)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13171",
    "data-name": "Path 13171",
    d: "M468.737,258.594q-.036-.549.776-1.054c.11-.071.3-.181.563-.334s.463-.267.592-.333a3.66,3.66,0,0,1,1.821-.442,3.817,3.817,0,0,1,1.854.535,2.328,2.328,0,0,1,.813.7.809.809,0,0,1,.128.7,1.115,1.115,0,0,1-.519.59l-.013.008a.233.233,0,0,1-.131.026.276.276,0,0,1-.131-.034l-.632-.365c-.054-.031-.08-.06-.083-.089a.17.17,0,0,1,.061-.111q.3-.288.228-.524a.965.965,0,0,0-.474-.464,1.95,1.95,0,0,0-2.009.039c-.124.063-.3.166-.544.306s-.427.246-.544.323q-1,.621-.067,1.16a2.042,2.042,0,0,0,.8.272,2.066,2.066,0,0,0,.909-.131.622.622,0,0,1,.191-.036.34.34,0,0,1,.155.048l.632.365a.106.106,0,0,1,.061.08c0,.032-.018.057-.059.077a2.748,2.748,0,0,1-1.026.3,3.863,3.863,0,0,1-1.209-.074,4.11,4.11,0,0,1-1.208-.47C469.072,259.316,468.761,258.959,468.737,258.594Z",
    transform: "translate(-468.736 -256.43)",
    fill: "url(#linear-gradient-12)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8539",
    "data-name": "Group 8539",
    transform: "translate(66.063 36.965)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13172",
    "data-name": "Path 13172",
    d: "M501.113,279.271a.417.417,0,0,1-.209-.056l-6.617-3.821a.417.417,0,0,1,0-.722l6.576-3.8a.42.42,0,0,1,.418,0l6.617,3.821a.417.417,0,0,1,0,.722l-6.576,3.8A.414.414,0,0,1,501.113,279.271Zm-5.783-4.239,5.783,3.339,5.742-3.315-5.783-3.339Z",
    transform: "translate(-494.078 -270.818)",
    fill: "#b086cc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8540",
    "data-name": "Group 8540",
    transform: "translate(61.08 34.321)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13173",
    "data-name": "Path 13173",
    d: "M489.043,270.717a.1.1,0,0,1,.062-.09l4.222-2.438a.322.322,0,0,1,.159-.043.306.306,0,0,1,.16.04l1.593.919q1.924,1.112.2,2.152c-.242.15-.408.249-.494.3s-.252.141-.511.281a3.65,3.65,0,0,1-1.834.488,3.914,3.914,0,0,1-1.869-.582l-1.625-.937A.106.106,0,0,1,489.043,270.717Zm2.409.576a2.067,2.067,0,0,0,1.022.313,2.205,2.205,0,0,0,1.054-.313c.268-.144.433-.236.5-.273s.225-.136.468-.285c.342-.21.515-.412.512-.606s-.187-.4-.553-.607l-.8-.46-3.034,1.752Z",
    transform: "translate(-489.043 -268.147)",
    fill: "url(#linear-gradient-13)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8548",
    "data-name": "Group 8548",
    transform: "translate(35.133 32.726)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8542",
    "data-name": "Group 8542",
    transform: "translate(5.414 1.949)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13174",
    "data-name": "Path 13174",
    d: "M404.289,262.931a.413.413,0,0,1-.208-.056l-6.618-3.821a.417.417,0,0,1,0-.722l6.576-3.8a.42.42,0,0,1,.418,0l6.618,3.821a.417.417,0,0,1,0,.722l-6.577,3.8A.414.414,0,0,1,404.289,262.931Zm-5.782-4.239,5.782,3.339,5.743-3.315-5.784-3.339Z",
    transform: "translate(-397.254 -254.478)",
    fill: "#b086cc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8543",
    "data-name": "Group 8543"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13175",
    "data-name": "Path 13175",
    d: "M391.783,254.144a.1.1,0,0,1,.059-.078l.071-.026,5.748-1.511a.52.52,0,0,1,.4.042l.719.416c.112.065.136.141.071.229l-2.617,3.319-.046.041a.306.306,0,0,1-.273,0l-.58-.334c-.092-.054-.113-.113-.066-.181l.483-.626-1.929-1.115-1.087.28a.415.415,0,0,1-.313-.039l-.58-.335A.1.1,0,0,1,391.783,254.144Zm3.018-.13,1.476.852,1.259-1.58Z",
    transform: "translate(-391.783 -252.508)",
    fill: "url(#linear-gradient-14)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8544",
    "data-name": "Group 8544",
    transform: "translate(25.616 13.613)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13176",
    "data-name": "Path 13176",
    d: "M424.7,274.717a.416.416,0,0,1-.209-.056l-6.618-3.821a.417.417,0,0,1,0-.722l6.576-3.8a.415.415,0,0,1,.418,0l6.618,3.821a.417.417,0,0,1,0,.722l-6.576,3.8A.413.413,0,0,1,424.7,274.717Zm-5.784-4.239,5.784,3.339,5.742-3.315-5.784-3.339Z",
    transform: "translate(-417.667 -266.263)",
    fill: "#b086cc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8545",
    "data-name": "Group 8545",
    transform: "translate(20.634 10.97)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13177",
    "data-name": "Path 13177",
    d: "M412.633,266.164a.1.1,0,0,1,.062-.091l4.222-2.437a.333.333,0,0,1,.159-.044.307.307,0,0,1,.16.04l1.893,1.093c.509.295.776.578.807.852s-.148.523-.532.745a1.807,1.807,0,0,1-.741.235,2.309,2.309,0,0,1-.728-.028.544.544,0,0,1,.062.5.915.915,0,0,1-.447.476,2.559,2.559,0,0,1-1.384.324,3.2,3.2,0,0,1-1.517-.448l-1.953-1.127A.106.106,0,0,1,412.633,266.164Zm2.6.751a1.42,1.42,0,0,0,.715.2,1.274,1.274,0,0,0,.658-.162c.19-.109.284-.238.278-.383s-.118-.28-.339-.41l-1.077-.621-1.31.755Zm1.919-1.183a1.437,1.437,0,0,0,.676.2,1.137,1.137,0,0,0,.613-.146c.182-.106.263-.221.246-.346s-.142-.252-.367-.383l-1.01-.584-1.168.674Z",
    transform: "translate(-412.633 -263.593)",
    fill: "url(#linear-gradient-15)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8546",
    "data-name": "Group 8546",
    transform: "translate(45.297 24.975)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13178",
    "data-name": "Path 13178",
    d: "M444.589,286.2a.414.414,0,0,1-.209-.056l-6.619-3.82a.418.418,0,0,1,0-.722l6.577-3.8a.415.415,0,0,1,.418,0l6.618,3.821a.417.417,0,0,1,0,.722l-6.576,3.8A.419.419,0,0,1,444.589,286.2Zm-5.784-4.238,5.784,3.339,5.741-3.315-5.783-3.339Z",
    transform: "translate(-437.553 -277.744)",
    fill: "#b086cc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8547",
    "data-name": "Group 8547",
    transform: "translate(40.982 22.727)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13179",
    "data-name": "Path 13179",
    d: "M433.195,277.636q-.036-.549.776-1.055.166-.105.563-.333c.267-.154.464-.266.592-.333a3.662,3.662,0,0,1,1.822-.442,3.826,3.826,0,0,1,1.853.534,2.332,2.332,0,0,1,.813.7.806.806,0,0,1,.127.7,1.112,1.112,0,0,1-.519.591l-.013.007a.233.233,0,0,1-.131.027.288.288,0,0,1-.131-.034l-.632-.365c-.053-.031-.08-.06-.083-.09a.164.164,0,0,1,.062-.11c.2-.192.278-.367.227-.524a.958.958,0,0,0-.473-.464,1.95,1.95,0,0,0-2.009.038c-.124.064-.3.166-.545.307s-.426.246-.544.323q-1,.62-.066,1.16a2.049,2.049,0,0,0,.8.272,2.071,2.071,0,0,0,.91-.131.612.612,0,0,1,.19-.036.343.343,0,0,1,.155.047l.632.366a.1.1,0,0,1,.061.08c0,.031-.018.057-.059.077a2.755,2.755,0,0,1-1.025.3,3.858,3.858,0,0,1-1.209-.074,4.1,4.1,0,0,1-1.209-.47C433.531,278.358,433.219,278,433.195,277.636Z",
    transform: "translate(-433.193 -275.472)",
    fill: "url(#linear-gradient-16)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8557",
    "data-name": "Group 8557",
    transform: "translate(0 53.509)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8549",
    "data-name": "Group 8549",
    transform: "translate(5.414 1.949)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13180",
    "data-name": "Path 13180",
    d: "M368.789,283.931a.413.413,0,0,1-.208-.056l-6.618-3.821a.417.417,0,0,1,0-.722l6.576-3.8a.415.415,0,0,1,.418,0l6.618,3.82a.417.417,0,0,1,0,.722l-6.577,3.8A.414.414,0,0,1,368.789,283.931Zm-5.782-4.239,5.782,3.339,5.743-3.315-5.784-3.339Z",
    transform: "translate(-361.754 -275.478)",
    fill: "#b086cc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8550",
    "data-name": "Group 8550"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13181",
    "data-name": "Path 13181",
    d: "M356.283,275.144a.1.1,0,0,1,.059-.078l.071-.026,5.748-1.511a.52.52,0,0,1,.4.042l.719.416c.112.065.136.141.071.229l-2.617,3.319-.046.041a.306.306,0,0,1-.273,0l-.58-.334c-.092-.054-.113-.113-.066-.181l.483-.626-1.929-1.115-1.087.28a.415.415,0,0,1-.313-.039l-.58-.335A.1.1,0,0,1,356.283,275.144Zm3.018-.13,1.476.852,1.259-1.579Z",
    transform: "translate(-356.283 -273.508)",
    fill: "url(#linear-gradient-17)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8551",
    "data-name": "Group 8551",
    transform: "translate(25.616 13.613)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13182",
    "data-name": "Path 13182",
    d: "M389.2,295.717a.416.416,0,0,1-.209-.056l-6.618-3.821a.417.417,0,0,1,0-.722l6.576-3.8a.415.415,0,0,1,.418,0l6.618,3.821a.417.417,0,0,1,0,.722l-6.576,3.8A.413.413,0,0,1,389.2,295.717Zm-5.784-4.239,5.784,3.339,5.742-3.315-5.784-3.339Z",
    transform: "translate(-382.167 -287.263)",
    fill: "#b086cc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8552",
    "data-name": "Group 8552",
    transform: "translate(20.634 10.97)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13183",
    "data-name": "Path 13183",
    d: "M377.133,287.164a.1.1,0,0,1,.062-.091l4.222-2.437a.334.334,0,0,1,.159-.044.307.307,0,0,1,.16.04l1.893,1.093c.509.295.776.578.807.852s-.148.523-.532.745a1.807,1.807,0,0,1-.741.235,2.31,2.31,0,0,1-.728-.028.544.544,0,0,1,.062.5.915.915,0,0,1-.447.476,2.559,2.559,0,0,1-1.384.324,3.2,3.2,0,0,1-1.517-.448l-1.953-1.127A.106.106,0,0,1,377.133,287.164Zm2.6.751a1.419,1.419,0,0,0,.715.2,1.274,1.274,0,0,0,.658-.162c.19-.109.284-.238.278-.383s-.118-.28-.339-.41l-1.077-.621-1.31.755Zm1.919-1.183a1.437,1.437,0,0,0,.676.2,1.136,1.136,0,0,0,.613-.146c.182-.106.263-.221.246-.346s-.142-.252-.367-.383l-1.01-.584-1.168.674Z",
    transform: "translate(-377.133 -284.593)",
    fill: "url(#linear-gradient-18)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8553",
    "data-name": "Group 8553",
    transform: "translate(45.297 24.975)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13184",
    "data-name": "Path 13184",
    d: "M409.089,307.2a.413.413,0,0,1-.209-.056l-6.619-3.82a.418.418,0,0,1,0-.722l6.577-3.8a.415.415,0,0,1,.418,0l6.618,3.821a.417.417,0,0,1,0,.722l-6.576,3.8A.419.419,0,0,1,409.089,307.2Zm-5.784-4.238,5.784,3.339,5.741-3.315-5.783-3.339Z",
    transform: "translate(-402.053 -298.744)",
    fill: "#b086cc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8554",
    "data-name": "Group 8554",
    transform: "translate(40.982 22.727)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13185",
    "data-name": "Path 13185",
    d: "M397.7,298.636q-.036-.549.776-1.055.166-.105.563-.333c.267-.154.464-.266.592-.333a3.663,3.663,0,0,1,1.822-.442,3.826,3.826,0,0,1,1.853.534,2.333,2.333,0,0,1,.814.7.807.807,0,0,1,.127.7,1.112,1.112,0,0,1-.519.591l-.013.007a.233.233,0,0,1-.131.027.288.288,0,0,1-.131-.034l-.632-.365c-.053-.031-.08-.06-.083-.09a.164.164,0,0,1,.062-.11c.2-.192.278-.367.227-.524a.958.958,0,0,0-.473-.464,1.95,1.95,0,0,0-2.009.038c-.124.064-.3.166-.545.307s-.426.246-.544.323q-1,.621-.066,1.16a2.048,2.048,0,0,0,.8.272,2.071,2.071,0,0,0,.91-.131.612.612,0,0,1,.19-.036.344.344,0,0,1,.155.047l.632.366a.1.1,0,0,1,.061.08c0,.031-.018.057-.059.077a2.756,2.756,0,0,1-1.025.3,3.859,3.859,0,0,1-1.209-.074,4.1,4.1,0,0,1-1.209-.47C398.031,299.358,397.719,299,397.7,298.636Z",
    transform: "translate(-397.694 -296.472)",
    fill: "url(#linear-gradient-19)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8555",
    "data-name": "Group 8555",
    transform: "translate(66.063 36.965)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13186",
    "data-name": "Path 13186",
    d: "M430.072,319.312a.414.414,0,0,1-.209-.056l-6.618-3.82a.417.417,0,0,1,0-.722l6.576-3.8a.415.415,0,0,1,.418,0l6.618,3.821a.417.417,0,0,1,0,.722l-6.577,3.8A.413.413,0,0,1,430.072,319.312Zm-5.783-4.238,5.783,3.339,5.741-3.315-5.783-3.339Z",
    transform: "translate(-423.036 -310.859)",
    fill: "#b086cc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8556",
    "data-name": "Group 8556",
    transform: "translate(61.081 34.321)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13187",
    "data-name": "Path 13187",
    d: "M418,310.759a.1.1,0,0,1,.061-.091l4.222-2.437a.335.335,0,0,1,.16-.044.315.315,0,0,1,.159.041l1.593.919q1.925,1.112.2,2.153c-.243.15-.408.249-.495.3s-.252.142-.511.282a3.661,3.661,0,0,1-1.834.488,3.907,3.907,0,0,1-1.868-.582l-1.626-.938A.1.1,0,0,1,418,310.759Zm2.408.576a2.077,2.077,0,0,0,1.022.313,2.22,2.22,0,0,0,1.055-.313c.267-.145.432-.237.5-.273s.226-.136.468-.285c.342-.21.516-.412.512-.606s-.187-.4-.552-.608l-.8-.46-3.035,1.753Z",
    transform: "translate(-418.002 -308.188)",
    fill: "url(#linear-gradient-20)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_13188",
    "data-name": "Path 13188",
    d: "M443.95,271.209l2.486-1.436-8.937-5.16-2.487,1.436Zm13.714-1.107-20.109-11.61-2.486,1.436,20.108,11.61Zm-44.905-16.9,20.109,11.611,2.487-1.436-20.109-11.61Zm41.077,6.817L419.944,240.45l-3.449,1.8,33.892,19.568Zm5.974,11.324-2.487,1.435,5,2.89,2.487-1.436Zm-13.715,1.106,16.981,9.8,2.487-1.435-16.981-9.8Zm19.126,11.043,18.172,10.491,2.487-1.436-18.173-10.491Zm23.991,4.827-22.254-12.848-2.487,1.435,22.255,12.849ZM413.1,250.526l-5.511-3.182L405.1,248.78l5.51,3.182Zm22.31,6.728-22.492-12.986-2.487,1.436,22.492,12.986Z",
    transform: "translate(-356.788 -219.657)",
    fill: "#b086cc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13189",
    "data-name": "Path 13189",
    d: "M405.52,290.362l2.487-1.435L403,286.038l-2.486,1.436Zm20.864,3.021-28.063-16.2-2.487,1.435,28.063,16.2Zm-48.123-18.759,20.109,11.61,2.487-1.435-20.109-11.61Zm67.7,30.059-17.428-10.062-2.487,1.436L443.47,306.12Zm-29.872-25.542-33.892-19.567-3.449,1.8,33.892,19.568Zm16.321,23.872-22.254-12.848-2.487,1.436,22.254,12.848Zm13.209,4.346,5.214,3.01,2.487-1.436-5.214-3.01ZM378.6,271.951l-8.908-5.142-2.487,1.435,8.908,5.143Zm17.573,3.992-21.151-12.211-2.487,1.436,21.151,12.211Z",
    transform: "translate(-356.396 -219.855)",
    fill: "#b086cc"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8559",
    "data-name": "Group 8559",
    transform: "translate(82.339)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13190",
    "data-name": "Path 13190",
    d: "M487.647,248.818q1.793-1.467,3.4-2.909L447.2,219.44c-.933,1-1.921,1.992-2.942,2.991Z",
    transform: "translate(-439.531 -219.44)",
    fill: "#b086cc"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8558",
    "data-name": "Group 8558",
    transform: "translate(0 5.301)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13191",
    "data-name": "Path 13191",
    d: "M493.569,256.183q-1.058.932-2.193,1.878l14.764,8.879q1-.984,1.94-1.966Z",
    transform: "translate(-440.018 -225.12)",
    fill: "#b086cc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13192",
    "data-name": "Path 13192",
    d: "M466.631,239.862q-1.1.966-2.276,1.945l16.71,10.051q1.033-1.018,2.008-2.034Z",
    transform: "translate(-439.739 -224.952)",
    fill: "#b086cc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13193",
    "data-name": "Path 13193",
    d: "M464.4,238.512,441.765,224.8c-.744.682-1.5,1.365-2.283,2.05L462.345,240.6Q463.407,239.553,464.4,238.512Z",
    transform: "translate(-439.482 -224.796)",
    fill: "#b086cc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13194",
    "data-name": "Path 13194",
    d: "M510.219,266.27q-1.036.913-2.145,1.835l10.051,6.045c.955-.624,1.761-1.174,2.4-1.638Z",
    transform: "translate(-440.191 -225.225)",
    fill: "#b086cc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13195",
    "data-name": "Path 13195",
    d: "M491.505,254.933l-6.272-3.8q-1.072.944-2.22,1.9l6.51,3.915Q490.543,255.939,491.505,254.933Z",
    transform: "translate(-439.932 -225.068)",
    fill: "#b086cc"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_13196",
    "data-name": "Path 13196",
    d: "M458.459,252.575l.726-6.017,1.387.168-.5,4.112,7.616-1.476.266,1.371Z",
    transform: "translate(-357.339 -219.72)",
    fill: "url(#radial-gradient-3)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8561",
    "data-name": "Group 8561",
    transform: "translate(329.741 212.527)"
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13197",
    "data-name": "Path 13197",
    d: "M417.658,276.934l10.2-16.221s18.941,19.364,17.924,21.251S417.658,276.934,417.658,276.934Z",
    transform: "translate(-330.829 -214.552)",
    fill: "url(#linear-gradient-21)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_13198",
    "data-name": "Path 13198",
    d: "M364.464,326.572l63.975-38.158s.54-.3.765-.387a106.674,106.674,0,0,1,14.765-6.269.136.136,0,0,1,.024-.014c1.018-.346,1.532-.055,1.271,1.165s-.754,1.949-2.217,3.252l-.025.014s-9.468,7.835-15.579,11.892a7.952,7.952,0,0,1-1.037.754l-.059.035v0L362.1,337.409Z",
    transform: "translate(-330.255 -214.768)",
    opacity: 0.2,
    fill: "url(#radial-gradient-4)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13199",
    "data-name": "Path 13199",
    d: "M409.094,302.4l28.694-17.115s.242-.132.343-.173a47.811,47.811,0,0,1,6.622-2.812l.011-.006c.456-.155.232,1.4-.425,1.981l-.007,0s-4.251,3.516-6.992,5.336a3.487,3.487,0,0,1-.465.337l-.027.016h0l-28.814,17.29Z",
    transform: "translate(-330.729 -214.775)",
    opacity: 0.3,
    fill: "url(#radial-gradient-5)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_203",
    "data-name": "Ellipse 203",
    cx: 3.081,
    cy: 23.677,
    rx: 3.081,
    ry: 23.677,
    transform: "translate(20.458 14.313) rotate(-62.293)",
    fill: "url(#radial-gradient-6)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13200",
    "data-name": "Path 13200",
    d: "M361.933,225.226l63.742,34.062a7.216,7.216,0,0,1,2.69,2.493l1.7,2.678a1.493,1.493,0,0,1-1.243,2.3l-4.181.048-65.8-35.405Z",
    transform: "translate(-330.221 -214.186)",
    fill: "url(#linear-gradient-22)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13201",
    "data-name": "Path 13201",
    d: "M358.825,231.461l65.8,35.405,1.524,3.195a1.476,1.476,0,0,1-1.128,2.1l-4.1.57-64.254-34.4Z",
    transform: "translate(-330.198 -214.25)",
    fill: "url(#linear-gradient-23)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13202",
    "data-name": "Path 13202",
    d: "M356.629,238.4l-3.471,4.243,63.092,33.8a3.449,3.449,0,0,0,3.128.065l1.547-.748a1.192,1.192,0,0,0,.7-1.792l-.744-1.17Z",
    transform: "translate(-330.162 -214.322)",
    fill: "url(#linear-gradient-24)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13203",
    "data-name": "Path 13203",
    d: "M339.78,235.633l9.436-17.513,12.424,6.667,0,0c.024.012.048.022.072.035,2.816,1.518,2.987,6.668.381,11.5s-7,7.526-9.818,6.009l-.068-.042,0,0Z",
    transform: "translate(-330.024 -214.112)",
    fill: "url(#linear-gradient-25)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13204",
    "data-name": "Path 13204",
    d: "M339.793,235.648c2.816,1.518,7.212-1.173,9.817-6.008s2.436-9.987-.381-11.5-7.212,1.173-9.817,6.009S336.976,234.131,339.793,235.648Z",
    transform: "translate(-330.001 -214.108)",
    fill: "url(#linear-gradient-26)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_13205",
    "data-name": "Path 13205",
    d: "M349.231,229.56c2.606-4.835,2.436-9.987-.381-11.5-.062-.034-.13-.054-.194-.084a3.477,3.477,0,0,1,.927.329c2.817,1.517,2.987,6.668.381,11.5-2.548,4.73-6.8,7.395-9.624,6.093C343.126,236.495,346.9,233.895,349.231,229.56Z",
    transform: "translate(-330.03 -214.111)",
    fill: "url(#radial-gradient-7)",
    style: {
      mixBlendMode: "color-dodge",
      isolation: "isolate"
    }
  }), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13206",
    "data-name": "Path 13206",
    d: "M331.992,230.805l8.812-16.353,7.495,4.013v0l.067.033c2.63,1.416,2.789,6.226.355,10.742s-6.538,7.028-9.167,5.61l-.064-.038v0Z",
    transform: "translate(-329.943 -214.074)",
    fill: "url(#linear-gradient-27)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13207",
    "data-name": "Path 13207",
    d: "M332,230.819c2.63,1.416,6.735-1.1,9.167-5.611s2.274-9.325-.355-10.742-6.734,1.095-9.167,5.61S329.374,229.4,332,230.819Z",
    transform: "translate(-329.922 -214.07)",
    fill: "url(#linear-gradient-28)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_13208",
    "data-name": "Path 13208",
    d: "M340.832,225.036c2.217-4.115,2.274-8.466.279-10.279.056.027.117.045.172.074,2.63,1.417,2.789,6.227.355,10.742s-6.538,7.029-9.167,5.611a3.279,3.279,0,0,1-.634-.463C334.47,231.945,338.45,229.455,340.832,225.036Z",
    transform: "translate(-329.942 -214.077)",
    fill: "url(#radial-gradient-8)",
    style: {
      mixBlendMode: "color-dodge",
      isolation: "isolate"
    }
  }), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13209",
    "data-name": "Path 13209",
    d: "M441.9,275.885a15.051,15.051,0,0,1-2.859,5.98c3.771.611,6.64.853,6.96.256C446.337,281.5,444.5,278.981,441.9,275.885Z",
    transform: "translate(-331.05 -214.709)",
    fill: "url(#radial-gradient-9)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8576",
    "data-name": "Group 8576",
    transform: "translate(436.628 90.438)"
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13210",
    "data-name": "Path 13210",
    d: "M437.925,193.276V96.43c0-4.1,2.492-5.984,5.567-4.208l113.423,65.626c3.075,1.775,5.567,6.537,5.567,10.636V265.33Z",
    transform: "translate(-437.925 -90.715)",
    fill: "url(#linear-gradient-29)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13211",
    "data-name": "Path 13211",
    d: "M564.082,264.483V167.637c0-4.1-2.492-8.86-5.567-10.636L445.091,91.375a3.758,3.758,0,0,0-3.257-.478c-.117.045-1.669.87-1.778.93l0,0a3.643,3.643,0,0,1,3.463.383l113.423,65.626c3.075,1.775,5.567,6.537,5.567,10.636v96.847Z",
    transform: "translate(-437.947 -90.707)",
    fill: "url(#linear-gradient-30)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13212",
    "data-name": "Path 13212",
    d: "M564.082,174.33v-6.693c0-4.1-2.492-8.86-5.567-10.636L445.091,91.375a3.758,3.758,0,0,0-3.257-.478c-.117.045-1.669.87-1.778.93l0,0a3.643,3.643,0,0,1,3.463.383l113.423,65.626c3.075,1.775,5.567,6.537,5.567,10.636v6.693Z",
    transform: "translate(-437.947 -90.707)",
    fill: "url(#linear-gradient-31)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13213",
    "data-name": "Path 13213",
    d: "M556.915,157.848,443.492,92.222c-3.075-1.775-5.567.109-5.567,4.208V103l124.557,72.054v-6.565C562.482,164.384,559.99,159.623,556.915,157.848Z",
    transform: "translate(-437.925 -90.715)",
    fill: "url(#linear-gradient-32)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13214",
    "data-name": "Path 13214",
    d: "M558.533,173.853v88.08l4.041,2.433v-88.41Z",
    transform: "translate(-439.171 -91.566)",
    fill: "url(#linear-gradient-33)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13215",
    "data-name": "Path 13215",
    d: "M559.133,224.1v33.4l2.853,1.675v-33.6Z",
    transform: "translate(-439.178 -92.085)",
    fill: "url(#linear-gradient-34)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13216",
    "data-name": "Path 13216",
    d: "M464.08,111.358c0,1.517-1.071,2.128-2.392,1.365A5.271,5.271,0,0,1,459.3,108.6c0-1.516,1.071-2.127,2.393-1.364A5.271,5.271,0,0,1,464.08,111.358Z",
    transform: "translate(-438.146 -90.874)",
    fill: "url(#linear-gradient-35)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13217",
    "data-name": "Path 13217",
    d: "M456.455,107.108c0,1.517-1.071,2.128-2.392,1.365a5.271,5.271,0,0,1-2.393-4.127c0-1.516,1.071-2.127,2.393-1.364A5.271,5.271,0,0,1,456.455,107.108Z",
    transform: "translate(-438.067 -90.83)",
    fill: "url(#linear-gradient-36)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13218",
    "data-name": "Path 13218",
    d: "M448.768,102.754c0,1.516-1.072,2.127-2.393,1.365a5.273,5.273,0,0,1-2.392-4.127c0-1.516,1.071-2.127,2.392-1.364A5.272,5.272,0,0,1,448.768,102.754Z",
    transform: "translate(-437.988 -90.785)",
    fill: "url(#linear-gradient-37)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_13219",
    "data-name": "Path 13219",
    d: "M437.925,126.553v48.028c.248.157.493.329.745.473,8.476,4.894,15.348-11.893,15.348-21.619s-6.871-21.58-15.348-26.474C438.42,126.817,438.171,126.683,437.925,126.553Z",
    transform: "translate(-437.925 -91.077)",
    opacity: 0.3,
    fill: "url(#radial-gradient-10)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13220",
    "data-name": "Path 13220",
    d: "M511.324,162.462l-11.8-6.78v2.392l11.8,6.78Zm1.711,3.38,8.743,5.027v-2.392l-8.743-5.027ZM497.81,154.694l-5.88-3.395v2.392l5.88,3.395Zm-7.591-4.382-13.6-7.824v2.392l13.6,7.824Zm-1.089-8.656-38.544-22.582v3.631l38.544,22.582Zm-14.22-.156-14.156-8.168v2.392l14.156,8.168Zm-15.866-9.155-8.458-5v2.392l8.458,5Z",
    transform: "translate(-438.056 -91)",
    fill: "url(#linear-gradient-38)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13221",
    "data-name": "Path 13221",
    d: "M523.982,213.492l2.828,1.632v-2.392l-2.828-1.632Zm-8.489-4.88,6.778,3.892v-2.392l-6.778-3.893ZM493.32,195.844l7.27,4.2v-2.392l-7.27-4.2Zm-8.9-5.109,7.185,4.121v-2.392l-7.185-4.121ZM502.3,201.029l11.483,6.6v-2.393L502.3,198.637Zm-39.728-22.9,20.143,11.624v-2.392l-20.143-11.625Zm-1.711-3.381-10.275-6.051v2.392l10.275,6.051Zm28.27,8.163-38.544-22.582v3.631l38.544,22.582Z",
    transform: "translate(-438.056 -91.426)",
    fill: "url(#linear-gradient-38)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_8562",
    "data-name": "Group 8562",
    transform: "translate(19.047 90.114)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13222",
    "data-name": "Path 13222",
    d: "M466.054,197.22a.492.492,0,0,1-.247-.067l-8.388-4.842a.493.493,0,0,1-.247-.429v-9.624a.495.495,0,0,1,.742-.429l8.388,4.843a.493.493,0,0,1,.247.428v9.625a.5.5,0,0,1-.495.495Zm-7.894-5.624,7.4,4.272v-8.482l-7.4-4.271Z",
    transform: "translate(-457.171 -181.761)",
    fill: "#b086cc"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_8563",
    "data-name": "Group 8563",
    transform: "translate(10.828 88.423)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13223",
    "data-name": "Path 13223",
    d: "M448.916,185.39a.338.338,0,0,1-.05-.172l.017-.075,1.984-4.975q.083-.19.3-.066l.911.526a.654.654,0,0,1,.3.409l1.984,7.268.017.1a.109.109,0,0,1-.054.111.126.126,0,0,1-.12-.012l-.737-.426a.529.529,0,0,1-.24-.319l-.38-1.369-2.447-1.413-.382.929c-.044.1-.124.109-.24.042l-.735-.426A.328.328,0,0,1,448.916,185.39Zm1.769-1.351,1.87,1.079-.934-3.463Z",
    transform: "translate(-448.866 -180.053)",
    fill: "url(#linear-gradient-40)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_8564",
    "data-name": "Group 8564",
    transform: "translate(44.654 104.898)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13224",
    "data-name": "Path 13224",
    d: "M491.928,212.158a.491.491,0,0,1-.247-.066l-8.388-4.843a.493.493,0,0,1-.247-.428v-9.625a.495.495,0,0,1,.742-.429l8.388,4.843a.493.493,0,0,1,.247.429v9.625a.495.495,0,0,1-.495.495Zm-7.894-5.623,7.4,4.271v-8.481l-7.4-4.272Z",
    transform: "translate(-483.045 -196.7)",
    fill: "#b086cc"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_8565",
    "data-name": "Group 8565",
    transform: "translate(36.964 102.317)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13225",
    "data-name": "Path 13225",
    d: "M475.333,200.62a.385.385,0,0,1-.058-.195v-6.178a.158.158,0,0,1,.053-.141.138.138,0,0,1,.144.018l2.4,1.385a4.043,4.043,0,0,1,1.448,1.324,3,3,0,0,1,.48,1.611,1.029,1.029,0,0,1-.211.718.628.628,0,0,1-.493.215,3.332,3.332,0,0,1,.587.926,2.648,2.648,0,0,1,.24,1.069q0,.883-.522,1.123a1.654,1.654,0,0,1-1.456-.3l-2.473-1.428A.388.388,0,0,1,475.333,200.62Zm2.39-2.474a.745.745,0,0,0,.649.139q.227-.105.228-.5a1.355,1.355,0,0,0-.224-.746,1.859,1.859,0,0,0-.653-.595l-1.283-.74v1.707Zm.083,2.953c.286.165.509.2.67.117a.575.575,0,0,0,.24-.55,1.609,1.609,0,0,0-.245-.829,1.81,1.81,0,0,0-.665-.654l-1.366-.789v1.918Z",
    transform: "translate(-475.275 -194.092)",
    fill: "url(#linear-gradient-41)"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_8566",
    "data-name": "Group 8566",
    transform: "translate(69.598 119.299)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13226",
    "data-name": "Path 13226",
    d: "M517.132,226.71a.491.491,0,0,1-.247-.066L508.5,221.8a.493.493,0,0,1-.247-.428v-9.625a.495.495,0,0,1,.742-.429l8.387,4.843a.493.493,0,0,1,.247.428v9.626a.495.495,0,0,1-.495.495Zm-7.893-5.624,7.4,4.272v-8.482l-7.4-4.271Z",
    transform: "translate(-508.25 -211.251)",
    fill: "#b086cc"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_8567",
    "data-name": "Group 8567",
    transform: "translate(61.702 117.389)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13227",
    "data-name": "Path 13227",
    d: "M500.945,214.908a4.622,4.622,0,0,1-.665-2.287q-.009-.261-.009-.84c0-.393,0-.675.009-.849q.04-1.192.67-1.507a1.928,1.928,0,0,1,1.762.338,5.25,5.25,0,0,1,1.282,1.03,4.9,4.9,0,0,1,.848,1.282,3.43,3.43,0,0,1,.319,1.314v.018a.092.092,0,0,1-.055.1.136.136,0,0,1-.119-.018l-.8-.464a.4.4,0,0,1-.148-.137.771.771,0,0,1-.083-.235,2.638,2.638,0,0,0-.43-1.077,2.571,2.571,0,0,0-.811-.711q-1.183-.683-1.232.808c-.006.166-.009.429-.009.783s0,.624.009.812a2.47,2.47,0,0,0,1.232,2.229,1.218,1.218,0,0,0,.807.225c.206-.043.351-.235.433-.58a.214.214,0,0,1,.083-.138c.033-.015.083,0,.148.034l.8.463a.38.38,0,0,1,.128.132.266.266,0,0,1,.046.168,1.4,1.4,0,0,1-.319.945,1.024,1.024,0,0,1-.848.3,2.968,2.968,0,0,1-1.282-.45A4.869,4.869,0,0,1,500.945,214.908Z",
    transform: "translate(-500.271 -209.322)",
    fill: "url(#linear-gradient-42)"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_8568",
    "data-name": "Group 8568",
    transform: "translate(19.047 49.538)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13228",
    "data-name": "Path 13228",
    d: "M466.054,156.22a.492.492,0,0,1-.247-.067l-8.388-4.842a.493.493,0,0,1-.247-.429v-9.624a.495.495,0,0,1,.742-.429l8.388,4.843a.493.493,0,0,1,.247.428v9.625a.5.5,0,0,1-.495.495Zm-7.894-5.624,7.4,4.272v-8.482l-7.4-4.271Z",
    transform: "translate(-457.171 -140.762)",
    fill: "#b086cc"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Group_8569",
    "data-name": "Group 8569",
    transform: "translate(10.828 47.847)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13229",
    "data-name": "Path 13229",
    d: "M448.916,144.39a.338.338,0,0,1-.05-.172l.017-.075,1.984-4.975q.083-.19.3-.066l.911.527a.654.654,0,0,1,.3.409l1.984,7.268.017.1a.109.109,0,0,1-.054.111.126.126,0,0,1-.12-.012l-.737-.426a.529.529,0,0,1-.24-.319l-.38-1.369-2.447-1.413-.382.929c-.044.1-.124.109-.24.042l-.735-.426A.328.328,0,0,1,448.916,144.39Zm1.769-1.351,1.87,1.079-.934-3.463Z",
    transform: "translate(-448.866 -139.053)",
    fill: "url(#linear-gradient-40)"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Group_8570",
    "data-name": "Group 8570",
    transform: "translate(44.654 64.322)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13230",
    "data-name": "Path 13230",
    d: "M491.928,171.158a.491.491,0,0,1-.247-.066l-8.388-4.843a.493.493,0,0,1-.247-.428v-9.625a.495.495,0,0,1,.742-.429l8.388,4.843a.493.493,0,0,1,.247.429v9.624a.495.495,0,0,1-.495.495Zm-7.894-5.623,7.4,4.271v-8.481l-7.4-4.272Z",
    transform: "translate(-483.045 -155.7)",
    fill: "#b086cc"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Group_8571",
    "data-name": "Group 8571",
    transform: "translate(36.964 61.741)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13231",
    "data-name": "Path 13231",
    d: "M475.333,159.62a.385.385,0,0,1-.058-.195v-6.178a.159.159,0,0,1,.053-.141.138.138,0,0,1,.144.018l2.4,1.385a4.043,4.043,0,0,1,1.448,1.324,3,3,0,0,1,.48,1.611,1.029,1.029,0,0,1-.211.718.628.628,0,0,1-.493.215,3.332,3.332,0,0,1,.587.926,2.648,2.648,0,0,1,.24,1.069q0,.883-.522,1.123a1.654,1.654,0,0,1-1.456-.3l-2.473-1.428A.387.387,0,0,1,475.333,159.62Zm2.39-2.474a.745.745,0,0,0,.649.139q.227-.105.228-.5a1.355,1.355,0,0,0-.224-.746,1.859,1.859,0,0,0-.653-.595l-1.283-.74v1.707Zm.083,2.953c.286.165.509.2.67.117a.574.574,0,0,0,.24-.55,1.609,1.609,0,0,0-.245-.829,1.81,1.81,0,0,0-.665-.654l-1.366-.789v1.918Z",
    transform: "translate(-475.275 -153.092)",
    fill: "url(#linear-gradient-41)"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Group_8572",
    "data-name": "Group 8572",
    transform: "translate(69.598 78.723)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13232",
    "data-name": "Path 13232",
    d: "M517.132,185.71a.491.491,0,0,1-.247-.066L508.5,180.8a.493.493,0,0,1-.247-.429v-9.624a.495.495,0,0,1,.742-.429l8.387,4.843a.493.493,0,0,1,.247.428v9.625a.495.495,0,0,1-.495.495Zm-7.893-5.624,7.4,4.272v-8.481l-7.4-4.272Z",
    transform: "translate(-508.25 -170.251)",
    fill: "#b086cc"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Group_8573",
    "data-name": "Group 8573",
    transform: "translate(61.702 76.813)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13233",
    "data-name": "Path 13233",
    d: "M500.945,173.908a4.623,4.623,0,0,1-.665-2.287q-.009-.261-.009-.84c0-.393,0-.675.009-.849q.04-1.192.67-1.507a1.928,1.928,0,0,1,1.762.338,5.27,5.27,0,0,1,1.282,1.029,4.923,4.923,0,0,1,.848,1.283,3.434,3.434,0,0,1,.319,1.314v.018a.092.092,0,0,1-.055.1.136.136,0,0,1-.119-.018l-.8-.464a.407.407,0,0,1-.148-.137.772.772,0,0,1-.083-.235,2.638,2.638,0,0,0-.43-1.077,2.571,2.571,0,0,0-.811-.711q-1.183-.683-1.232.808c-.006.166-.009.429-.009.783s0,.624.009.812a2.472,2.472,0,0,0,1.232,2.23,1.222,1.222,0,0,0,.807.224c.206-.043.351-.235.433-.58a.214.214,0,0,1,.083-.138c.033-.015.083,0,.148.034l.8.463a.38.38,0,0,1,.128.132.266.266,0,0,1,.046.168,1.4,1.4,0,0,1-.319.945,1.024,1.024,0,0,1-.848.3,2.969,2.969,0,0,1-1.282-.45A4.869,4.869,0,0,1,500.945,173.908Z",
    transform: "translate(-500.271 -168.322)",
    fill: "url(#linear-gradient-42)"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Group_8574",
    "data-name": "Group 8574",
    transform: "translate(95.919 134.496)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13234",
    "data-name": "Path 13234",
    d: "M543.729,242.066a.492.492,0,0,1-.247-.067l-8.388-4.843a.493.493,0,0,1-.247-.428V227.1a.495.495,0,0,1,.742-.428l8.388,4.842a.5.5,0,0,1,.247.429v9.625a.5.5,0,0,1-.495.495Zm-7.894-5.624,7.4,4.271v-8.481l-7.4-4.271Z",
    transform: "translate(-534.846 -226.607)",
    fill: "#b086cc"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "Group_8575",
    "data-name": "Group 8575",
    transform: "translate(88.231 131.916)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13235",
    "data-name": "Path 13235",
    d: "M527.134,230.529a.393.393,0,0,1-.057-.2v-6.179a.151.151,0,0,1,.053-.139.133.133,0,0,1,.144.017l2.018,1.165a4.525,4.525,0,0,1,2.491,4.019c.01.373.016.623.016.75s-.006.36-.016.721q-.034,1.311-.625,1.6t-1.824-.423l-2.06-1.189A.394.394,0,0,1,527.134,230.529Zm2.158.21c.458.265.789.338.993.223s.312-.443.323-.981c.012-.374.017-.608.017-.7s0-.338-.017-.712a2.726,2.726,0,0,0-.339-1.339,2.686,2.686,0,0,0-1.016-.953l-1.009-.584v4.443Z",
    transform: "translate(-527.077 -224)",
    fill: "url(#linear-gradient-46)"
  }))), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13236",
    "data-name": "Path 13236",
    d: "M484.283,202.628l2.969,5.113,7.587-4.288-1.814-2.474-5.361,5.278-.99-3.959Z",
    transform: "translate(-438.404 -91.846)",
    fill: "url(#linear-gradient-47)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuiz);
export default __webpack_public_path__ + "static/media/quiz.1805882c6cb73c9d680f822249559189.svg";
export { ForwardRef as ReactComponent };